import type { StorageAdapter } from './storage-adapter';

/** In-memory adapter for tests and for sessions where the browser refuses to persist. */
export function createMemoryStorage(): StorageAdapter {
  const entries = new Map<string, string>();
  return {
    get: (key) => entries.get(key) ?? null,
    set: (key, value) => void entries.set(key, value),
    remove: (key) => void entries.delete(key),
  };
}
